import fetchWithHeaders from '../../configs/fetchWithHeaders'
import Head from 'next/head'
import { fetchNavigationMenu } from '../../configs/serverSideNavItems'
import UserLayout from '../../layouts/UserLayout'

const PrivacyPage = ({ privacy_terms }) => {
  return (
    <>
      <Head>
        <title>{privacy_terms.title}</title>
        <meta name='robots' content='noindex, nofollow' />
        <meta name='googlebot' content='noindex, nofollow' />
      </Head>
      <div>
        <h3>{privacy_terms.title}</h3>
        <p>{privacy_terms.description}</p>
      </div>
    </>
  )
}

export async function getStaticProps({ locale }) {
  const menuItems = await fetchNavigationMenu(locale)

  try {
    const res = await fetchWithHeaders(`/privacy-page?lang=${locale}`)
    if (!res.ok) {
      throw new Error(`Failed to fetch privacy terms: ${res.statusText}`)
    }
    const privacy_terms = await res.json()

    return {
      props: {
        privacy_terms: privacy_terms[0],
        menuItems
      }
    }
  } catch (error) {
    console.error(error.message)

    return {
      notFound: true
    }
  }
}

PrivacyPage.getLayout = page => <UserLayout menuItems={page.props.menuItems}>{page}</UserLayout>

export default PrivacyPage
